module.exports = __webpack_public_path__ + "img/s2.7a209184.jpg";